<div class="filter-list">
  @if (error) {
    <error-message
      [error]="error"
      [page]="'Filters'">
    </error-message>
  }
  @if (!error && !loading) {
    <div>
      @for (category of filters; track category.id || category.name || $index; let i = $index) {
        <div>
          <button type="button"
            fxLayout="row"
            fxLayoutAlign="space-between center"
            class="filter-list__category-container"
            [ngClass]="{'filter-list__category-separator': i > 0}"
            [attr.aria-expanded]="!!category.open"
            (click)="categoryToggled(category)">
            <div class="filter-list__category-name" [attr.data-testid]="category.name + '-category-name'">
              {{category.name}} @if (category.hasAFilterSelected) {
              <span>*</span>
            }
          </div>
          <mat-icon [@arrowState]="getCategoryState(category)"
            class="filter-list__arrow">
            chevron_right
          </mat-icon>
        </button>
        @if (category.open && !category.savedGroupsCategory) {
          <div class="filter-list__category-filters-container">
            @for (filter of category.subFilters; track filter.id || filter.name || $index) {
              @if (filter.id !== filterOnBetween) {
                <div class="filter-list__filter-container">
                  <div fxLayout="row" fxLayoutAlign="space-between start">
                    <div fxLayout="row" fxLayoutAlign="start start">
                      @if (!filter.hideCheckBox) {
                        <div class="filter-list__checkbox">
                          <mat-checkbox [checked]="filter.isSelected" [attr.data-testid]="filter.name + '-checkbox'" (change)="filterToggled($event.checked, filter)">
                          </mat-checkbox>
                        </div>
                      }
                      <div fxLayout="column" fxLayoutAlign="start start">
                        <div fxLayout="row" fxLayoutAlign="start center">
                          <div class="filter-list__name" [attr.data-testid]="filter.name + '-filter-name'">
                            {{filter.name}}
                            @if (filter.infoText) {
                              <help-text
                                class="filter-list__help-text"
                                [displayOnLeft]="true"
                                [helpText]="filter.infoText"
                                [isSmallIcon]="true">
                              </help-text>
                            }
                          </div>
                        </div>
                        <div class="filter-list__subtext">{{filter.subtext}}</div>
                        @if (filter.autoCompleteEnabled) {
                          <div
                            class="filter-list__autocomplete">
                            <spot-autocomplete [items]="filteredCustomers"
                              [loading]="autocompleteCustomersLoading"
                              [placeholder]="customerSearchPlaceholder"
                              [noResultsText]="noCustomerResultsText"
                              [isBorderStyling]="true"
                              (valueChange)="onCustomerSearch($event)"
                              (selectionMade)="onCustomerSelection($event, filter)">
                            </spot-autocomplete>
                          </div>
                        }
                        @if (filter.isSelected && filter.buttonToggles) {
                          <button-toggle
                            class="filter-list__button-toggle"
                            [buttons]="filter.buttonToggles"
                            (buttonToggled)="buttonToggled(category.id, filter, $event)">
                          </button-toggle>
                        }
                        @if (filter.isSelected && filter.buttonChipSections) {
                          <div>
                            @for (chipSection of filter.buttonChipSections; track chipSection.id || chipSection.name || $index) {
                              <button-chip-section
                                [name]="chipSection.name"
                                [buttonChips]="chipSection.buttonChips"
                                [isMobile]="mobile"
                                (buttonChipToggled)="buttonChipToggled($event, filter, chipSection)">
                              </button-chip-section>
                            }
                          </div>
                        }
                        @if (filter.isSelected && filter.subOptions) {
                          <div class="filter-list__sub-options">
                            @for (subOption of filter.subOptions; track subOption.id || subOption.name || $index) {
                              <filter-sub-option
                                [name]="subOption.name"
                                [image]="subOption.image"
                                [selected]="subOption.selected"
                                [subtext]="subOption.subtext"
                                (subOptionToggled)="subOptionToggled(filter, subOption)">
                              </filter-sub-option>
                            }
                          </div>
                        }
                        @if (filter.isSelected && filter.displaySlider) {
                          <div>
                            @if (filter.sliderOptions.highValue !== null) {
                              <double-slider
                                [filter]="filter"
                                (twoVariableSliderValueUpdated)="twoVariableSliderValueUpdated.emit($event)">
                              </double-slider>
                            }
                            @if (filter.sliderOptions.highValue === null) {
                              <single-slider
                                [filter]="filter"
                                (sliderValueUpdated)="sliderValueUpdated.emit($event)">
                              </single-slider>
                            }
                          </div>
                        }
                        @if (filter.isSelected && filter.displayDateSelection) {
                          <date-range-picker
                            [isMobile]="mobile"
                            [stacked]="true"
                            [startDate]="filtersStartDate"
                            [endDate]="filtersEndDate"
                            [pastDatesOnly]="pastDatesOnly"
                            (datesChanged)="updateDate($event)">
                          </date-range-picker>
                        }
                      </div>
                    </div>
                    <div class="filter-list__icon-container" fxLayout="row" fxLayoutAlign="center center">
                      @if (filter.image) {
                        <img alt="" class="filter-list__icon" [src]="filter.image">
                      }
                    </div>
                  </div>
                </div>
              }
            }
          </div>
        }
        @if (category.open && category.savedGroupsCategory) {
          <div class="filter-list__category-filters-container">
            @if (savedGroupsLoading) {
              <div [cfaLoading]="savedGroupsLoading" class="filter-list__loading"></div>
            }
            @if (savedGroupsError) {
              <error-message
                [error]="savedGroupsError"
                [page]="'Filters Saved Groups'">
              </error-message>
            }
            @if (!savedGroupsLoading && !savedGroupsError) {
              <div>
                @if (savedGroups.length === 0) {
                  <div>
                    <div class="filter-list__no-results-text">
                      No results were found. Looks like you have no saved groups.
                    </div>
                  </div>
                }
                @if (savedGroups.length > 0) {
                  <div>
                    @for (savedGroup of savedGroups; track savedGroup.id || savedGroup.name || $index) {
                      <div class="filter-list__saved-group-container" fxLayout="row" fxLayoutAlign="start start">
                        <div class="filter-list__checkbox" fxFlex="10">
                          <mat-checkbox [checked]="savedGroup.isSelected"
                            [disabled]="savedGroupEditActive"
                            [attr.data-testid]="savedGroup.name + '-checkbox'"
                            (change)="savedGroupToggled($event.checked, savedGroup)">
                          </mat-checkbox>
                        </div>
                        <div fxLayout="column" fxFlex="90">
                          <div fxLayout="row" fxLayoutAlign="start center">
                            <div class="filter-list__name" fxFlex="80"
                              [ngClass]="{'filter-list__name-disabled': savedGroupEditActive}">
                              {{savedGroup.name}}
                            </div>
                            @if ((page === meetPage) && displaySavedGroupActions && !savedGroupEditActive && !savedGroupEditDisabled) {
                              <div
                                fxFlex="10">
                                <button type="button"
                                  class="filter-list__icon-button"
                                  [attr.data-testid]="savedGroup.name + '-edit-button'"
                                  aria-label="Edit"
                                  (click)="savedGroupEdit(savedGroup)">
                                  <img class="filter-list__edit-icon" alt="" src="{{editIconUrl}}">
                                </button>
                              </div>
                            }
                            <div fxFlex="10">
                              @if ((page === meetPage) && !savedGroupEditActive && !savedGroupEditDisabled) {
                                <button type="button"
                                  class="filter-list__icon-button"
                                  [attr.data-testid]="savedGroup.name + '-delete-button'"
                                  aria-label="Delete"
                                  (click)="savedGroupDelete(savedGroup)">
                                  <img class="filter-list__delete-icon" alt="" src="{{deleteIconUrl}}">
                                </button>
                              }
                            </div>
                          </div>
                          <div class="filter-list__subtext" [attr.data-testid]="savedGroup.name + '-subtext'">
                            {{savedGroup.customerCount}} customers as of last update on {{savedGroup.updateAt | locTimeZoneDate:'M/D/YYYY'}}
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}
<div>
  @if (mobile && page === meetPage) {
    @if (!savedGroupEditActive) {
      <div class="filter-list__button-container">
        @if (!displayCustomerLoading) {
          <button
            type="button"
            mat-raised-button
            class="filter-list__button"
            (click)="goBack.emit()">
            @if (totalCustomers === 1) {
              <span>Show {{totalCustomers}} Customer</span>
            }
            @if (totalCustomers !== 1) {
              <span>Show {{totalCustomers}} Customers</span>
            }
          </button>
        }
        @if (displayCustomerLoading) {
          <button type="button" mat-raised-button
            class="filter-list__button">
            <mat-spinner strokeWidth="3" [diameter]="25"></mat-spinner> Loading...
          </button>
        }
      </div>
    }
    @if (savedGroupEditActive) {
      <div class="filter-list__button-container">
        <button type="button" mat-raised-button
          class="filter-list__button"
          [disabled]="(selectedFilters.length === 0) && (includedCustomers.length === 0) && (excludedCustomers.length === 0)"
          (click)="updateSavedGroup.emit()">
          Update {{savedGroupEditName}}
        </button>
      </div>
    }
  }
  @if (mobile && page === engagePage) {
    <div class="filter-list__button-container">
      <button type="button" mat-raised-button
        class="filter-list__select-all-button"
        (click)="selectAllCustomers.emit()">
        Select All Spotlight
      </button>
      @if (!displayCustomerLoading) {
        <button
          type="button"
          mat-raised-button
          class="filter-list__apply-button"
          [disabled]="isApplyDisabled()"
          (click)="apply.emit()">
          Apply
          @if (!isApplyDisabled()) {
            <span>
              ({{selectedEngageCustomers | number:'1.0':'en-US'}})
            </span>
          }
        </button>
      }
      @if (displayCustomerLoading) {
        <button
          type="button"
          mat-raised-button
          class="filter-list__apply-button">
          <mat-spinner strokeWidth="3" [diameter]="25"></mat-spinner> Loading...
        </button>
      }
    </div>
  }
</div>
</div>
